import { Fragment, useMemo } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { __MANAGEMENT_API_URL__ } from 'shell/constants/environment';
import FormInstitution, { InstitutionForm } from 'system/components/institution/form';
import { useHttpFetch } from 'shell/hooks/use-old-http-fetch';
import { Institution } from 'shell/models/institution';
import { HttpResponse } from 'shell/models/http-response';
import { useEffect } from 'react';
import { noop } from 'shell/utils/noop';
import Breadcrumbs from 'shell/components/shared/breadcrumb';
import { CommonInstitutionCrumbs } from '../constants';

const InstitutionDetailPage = (): React.ReactElement => {
  const params = useParams();
  const {
    data,
    loading,
    error,
    get: getInstitution,
  } = useHttpFetch<HttpResponse<Institution>>(`${__MANAGEMENT_API_URL__}/enti/${params.id}`, {
    data: {},
  });

  const institution: InstitutionForm = useMemo(() => {
    const ente = data?.payload;
    if (!ente || !!error) {
      return {
        istat: '',
        officeNumber: 0,
        province: '',
        note: '',
        mayor: '',
        mayorFiscalCode: '',
        code: '',
        description: '',
        anpr: false,
        name: null,
      };
    }
    return {
      istat: ente.codiceIstat,
      name: {
        description: ente.nome,
      },
      officeNumber: ente.numeroUfficiStatoCivile,
      province: ente.provincia,
      code: ente.key?.codice,
      mayor: ente.sindaco ? ente.sindaco : '',
      mayorFiscalCode: ente.codFiscaleSindaco ? ente.codFiscaleSindaco : '',
      description: '',
      anpr: false,
      lastUpdate: ente.note,
      direction: ente.descrizioneDirezione,
    };
  }, [data]);

  const navigate = useNavigate();

  useEffect(() => {
    getInstitution();
  }, [params.id]);

  return (
    <Fragment>
      <Breadcrumbs items={[...CommonInstitutionCrumbs, { name: 'Dettaglio Ente' }]} />
      {loading && !data ? null : (
        <FormInstitution
          title={'Dettaglio Ente'}
          onOk={noop}
          onCancel={() => {
            navigate('/sistema/enti');
          }}
          disabled
          initialValues={institution}
        />
      )}
    </Fragment>
  );
};

InstitutionDetailPage.displayName = 'Institution Detail page component';

export default InstitutionDetailPage;
